const validate = (values: any, props: any) => {
  const errors: any = {};

  // Basic required fields
  if (!values.bracketName) errors.bracketName = "Bracket Name is required";
  if (!values.eligibleParticipants)
    errors.eligibleParticipants = "Select participants";
  if (!values.bracketStyle) errors.bracketStyle = "Select bracket style";

  if (values.bracketStyle !== "Round Robin") {
    const roundsKey =
      values.eligibleParticipants === "all" ? "allTeams" : "checkedInTeams";

    const bracketRounds = values.bracketRounds || {};
    const roundsData = bracketRounds || {};

    if (props.bracketRounds && props.bracketRounds[roundsKey]) {
      Object.entries(props.bracketRounds[roundsKey]).forEach(
        ([sectionKey, rounds]: any) => {
          if (!Array.isArray(rounds)) return;

          rounds.forEach((round: any, index: number) => {
            const roundValues = roundsData?.[sectionKey]?.[index] || {};

            if (!roundValues.roundName || !roundValues.roundName.trim()) {
              errors.bracketRounds = errors.bracketRounds || {};
              errors.bracketRounds[sectionKey] =
                errors.bracketRounds[sectionKey] || [];
              errors.bracketRounds[sectionKey][index] = {
                ...(errors.bracketRounds[sectionKey][index] || {}),
                roundName: "Round Name is required",
              };
            }

            if (!roundValues.matchFormat) {
              errors.bracketRounds = errors.bracketRounds || {};
              errors.bracketRounds[sectionKey] =
                errors.bracketRounds[sectionKey] || [];
              errors.bracketRounds[sectionKey][index] = {
                ...(errors.bracketRounds[sectionKey][index] || {}),
                matchFormat: "Match Format is required",
              };
            }
          });
        }
      );
    }
  }

  if (values.bracketStyle === "Round Robin") {

    if (!values.matchFormat) {
      errors.matchFormat = "Select Best Of option";
    }

    if (!values.rankBy) {
      errors.rankBy = "Select Rank Wise option";
    }

    if (values.rankBy === "Custom Ranking") {
      if (
        values.winScore === undefined ||
        values.winScore === null ||
        values.winScore === ""
      ) {
        errors.winScore = "Win Points are required for Custom ranking";
      } else if (Number(values.winScore) <= 0) {
        errors.winScore = "Win Points must be greater than 0";
      }

      if (
        values.tieScore === undefined ||
        values.tieScore === null ||
        values.tieScore === ""
      ) {
        errors.tieScore = "Tie Points are required for Custom ranking";
      } else if (Number(values.tieScore) < 0) {
        errors.tieScore = "Tie Points cannot be negative";
      }
    }
  }

  return errors;
};

export default validate;
